import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../../common/functionUtils';

const CoverageDate = ({coverages}) => {

    
    return (
        <>
           {coverages ? ` from  ${formatDate(coverages[0]?.effectiveDate)}` : ''}
        </>
    );
};
CoverageDate.propTypes = {
    coverages: PropTypes.any
};
export default CoverageDate;
